import { HeaderSimple, Icon, LabelTag, useResponsive, VARIANTS } from '@aptuno/aptuno-ui';
import { FC } from 'react';
import {
  IconClose,
  InfoItemIcon,
  InfoItemIconWrapper,
  InfoItemTitle,
  InfoListContainer,
  InfoListItem,
  InfoListItemTextContainer,
  LoadPhotoButton,
  LoadPhotosInfoScreenContent,
  TextNormal,
  TitleText,
} from './LoadPhotosInfoScreen.styled';

type Props = {
  onBackClick: () => void;
  onLeave: () => void;
  onAddPicture: (file: File) => void;
  isLoadPictureDisabled: boolean;
};

export const LoadPhotosInfoScreen: FC<Props> = ({ onBackClick, onLeave, onAddPicture, isLoadPictureDisabled }) => {
  const PICTURE_VALID_FILE_TYPES = ['image/jpg', 'image/jpeg', 'image/png'];
  const { isMobile } = useResponsive();

  const handleOnBackClick = () => {
    onBackClick();
  };

  const handleOnLeave = () => {
    onLeave();
  };

  return (
    <div>
      <HeaderSimple withBorderRadius={false} maxWidth="100%" isFixed={false} onButtonBack={handleOnBackClick}>
        <TitleText>Recomendaciones para tu foto</TitleText>
        <IconClose icon={'closeAlt'} color={'#9B9B9B'} marginRight={'16px !important'} onClick={handleOnLeave} />
      </HeaderSimple>
      <LoadPhotosInfoScreenContent isMobile={isMobile}>
        <LabelTag>Consejos generales</LabelTag>
        <InfoListContainer>
          <InfoListItem>
            <InfoItemIconWrapper>
              <InfoItemIcon icon={'Sun'} />
            </InfoItemIconWrapper>
            <InfoListItemTextContainer>
              <InfoItemTitle>Tu cara debe estar bien iluminada</InfoItemTitle>
              <TextNormal>
                Necesitamos una foto en la que podamos verte claramente. Evita tomar la foto a contraluz o con sombras
                fuertes.
              </TextNormal>
            </InfoListItemTextContainer>
          </InfoListItem>
          <InfoListItem>
            <InfoItemIconWrapper>
              <InfoItemIcon icon={'mobile'} />
            </InfoItemIconWrapper>
            <InfoListItemTextContainer>
              <InfoItemTitle>Captura desde un lugar estable</InfoItemTitle>
              <TextNormal>
                Puedes apoyar tu teléfono contra algún objeto sólido para tomar la foto. Evita que quede borrosa o poco
                clara.
              </TextNormal>
            </InfoListItemTextContainer>
          </InfoListItem>
          <InfoListItem>
            <InfoItemIconWrapper>
              <InfoItemIcon icon={'user'} />
            </InfoItemIconWrapper>
            <InfoListItemTextContainer>
              <InfoItemTitle>No tapes tu cara con el documento</InfoItemTitle>
              <TextNormal>
                Ubica el documento a un lado de tu cara, sin tapar ninguna de tus facciones. Queremos verte la cara
                completa.
              </TextNormal>
            </InfoListItemTextContainer>
          </InfoListItem>
        </InfoListContainer>
        <LoadPhotoButton
          isDisabled={isLoadPictureDisabled}
          isMobile={isMobile}
          accept={PICTURE_VALID_FILE_TYPES}
          onFileAdded={onAddPicture}
          appearance={VARIANTS.INFORMATIVE}
        >
          <Icon icon={'plus'} />
          Cargar foto
        </LoadPhotoButton>
      </LoadPhotosInfoScreenContent>
    </div>
  );
};
